import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import PedidosNavbar from './PedidosNavbar'

const RootStyle = styled('div')(({ theme }) => ({
	height: '100%',
	padding: '15px 0px 0px 0px',
	flexGrow: 1
}));

export default function ChatLayout() {
	return <>
		<PedidosNavbar menu={false} title='Chat' />
		<RootStyle>
			<Grid container justifyContent='center' sx={{ height: '100%' }} >
				<Grid item xs={12} md={4} sx={{ height: '100%' }}>
					<Outlet />
				</Grid>
			</Grid>
		</RootStyle>
	</>
}
